module.exports = "/_next/static/images/AWSCDVirtualEdition2-809a3de5143ee1d62f0ac1789c19926f.jpg";